import React, { useEffect, useState } from 'react';
import { LockIcon, TruckIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => s <= 1 ? initialSeconds : s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [initialSeconds]);
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return {
    mm,
    ss
  };
}
export function FinalCTASection() {
  const {
    mm,
    ss
  } = useCountdown(12 * 60);
  return <section className="bg-gradient-to-br from-green-800 to-green-900 py-16 sm:py-24" data-id="element-76">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="max-w-2xl mx-auto text-center flex flex-col items-center gap-8" data-id="element-78">
          <div className="flex flex-col gap-4" data-id="element-79">
            <div className="inline-flex items-center gap-2 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full mx-auto uppercase tracking-wide" data-id="element-80">
              🔥 Últimas unidades disponibles
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-81">
              Es Momento de Volver a{' '}
              <span className="text-green-400" data-id="element-82">Sentirte Ligera</span>
            </h2>
            <p className="text-green-200 text-lg leading-relaxed" data-id="element-83">
              Da el primer paso hacia un metabolismo más equilibrado. Sin
              extremos, sin promesas vacías. Con respaldo médico y garantía
              total.
            </p>
          </div>

          <a href="#pricing" className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg sm:text-xl px-12 py-5 rounded-xl transition-all duration-200 tracking-wide shadow-xl hover:shadow-2xl w-full max-w-md text-center" data-id="element-84">
            PROBAR TRIMORA AHORA →
          </a>

          {/* Mini countdown */}
          <div className="flex flex-col items-center gap-2" data-id="element-85">
            <p className="text-green-300 text-xs font-semibold uppercase tracking-widest" data-id="element-86">
              Oferta expira en
            </p>
            <div className="flex items-center gap-2" data-id="element-87">
              <div className="bg-green-950 border border-green-700 rounded-lg px-4 py-2" data-id="element-88">
                <span className="text-2xl font-bold text-green-400 tabular-nums" data-id="element-89">
                  {mm}
                </span>
              </div>
              <span className="text-green-400 text-2xl font-bold" data-id="element-90">:</span>
              <div className="bg-green-950 border border-green-700 rounded-lg px-4 py-2" data-id="element-91">
                <span className="text-2xl font-bold text-green-400 tabular-nums" data-id="element-92">
                  {ss}
                </span>
              </div>
            </div>
          </div>

          {/* Stars + count */}
          <div className="flex flex-col items-center gap-2" data-id="element-93">
            <div className="flex gap-1" data-id="element-94">
              <StarIcon className="w-5 h-5 text-green-400 fill-green-400" data-id="element-95" />
              <StarIcon className="w-5 h-5 text-green-400 fill-green-400" data-id="element-96" />
              <StarIcon className="w-5 h-5 text-green-400 fill-green-400" data-id="element-97" />
              <StarIcon className="w-5 h-5 text-green-400 fill-green-400" data-id="element-98" />
              <StarIcon className="w-5 h-5 text-green-400 fill-green-400" data-id="element-99" />
            </div>
            <p className="text-green-200 text-sm font-medium" data-id="element-100">
              10.000+ clientas satisfechas en España
            </p>
          </div>

          {/* Trust icons */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-green-200" data-id="element-101">
            <div className="flex items-center gap-2" data-id="element-102">
              <LockIcon className="w-5 h-5 text-green-300" data-id="element-103" />
              <span className="text-sm" data-id="element-104">Pago seguro SSL</span>
            </div>
            <div className="w-px h-4 bg-green-600 hidden sm:block" data-id="element-105"></div>
            <div className="flex items-center gap-2" data-id="element-106">
              <TruckIcon className="w-5 h-5 text-green-300" data-id="element-107" />
              <span className="text-sm" data-id="element-108">Envío en España</span>
            </div>
            <div className="w-px h-4 bg-green-600 hidden sm:block" data-id="element-109"></div>
            <div className="flex items-center gap-2" data-id="element-110">
              <ShieldCheckIcon className="w-5 h-5 text-green-300" data-id="element-111" />
              <span className="text-sm" data-id="element-112">Garantía 90 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}